import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import LoginPrivateRoute from "./LoginPrivateRoute";

const Loading = () => <div>Loading...</div>;
const Main = lazy(() => import("../pages/Main/index.jsx"));
const Login = lazy(() => import("../pages/Login/index.jsx"));
const NoMatch = lazy(() => import("../pages/NoMatch/index.jsx"));

const RouterExport = () => (
  <Suspense fallback={<Loading />}>
    <Router basename={`${process.env.PUBLIC_URL}`}>
      <Switch>
        <Route path="/404" component={NoMatch} />
        <PrivateRoute exact path="/Dashboard" component={Main} />
        <LoginPrivateRoute exact path="/" component={Login} />
        <Redirect from="*" to="/404" />
      </Switch>
    </Router>
  </Suspense>
);

export default RouterExport;
